/**
 * Adiciona a funcionalidade de mostrar todos os markers do mapa.
 * @author: adalto.junior
 * Date: 05/05/2014
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.Events = function () {

    this.routeId = null;

    this.setRouteId = function (routeId) {

        this.routeId = routeId;

    };

    this.addListeners = function () {

    };

};

